import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/company/membership-regulations/MembershipRegulations.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Company/MembershipRegulations/components/SectionHeader/'));
const SectionRequirements = dynamic(() => import('sections/Company/MembershipRegulations/components/SectionRequirements/'));

export default function MembershipRegulations() {
  return (
    <div className={cn('membership-regulations')}>
      <SectionHeader /> 
      <SectionRequirements /> 
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Membership Regulations at DF Alliance | DF Alliance',
      description:
        'Review DF Alliance\'s membership regulations online to ensure a smooth and seamless experience while joining our global freight forwarding network.',
      keywords: 'freight member regulations, freight alliance regulation',
      path: '/company/membership-regulations',
    },
  };
};

MembershipRegulations.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
